import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Children, useRef, useEffect, useReducer, useCallback, cloneElement } from "react";
import classnames from "classnames";
import { useIntersectionObserver } from "@/hooks";
import DropdownMenu from "@/components/DropdownMenu";
import styles from "@/styles/OverflowMenu.module.scss";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconEllipsis = function IconEllipsis(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Zm6,0A1.5,1.5,0,1,1,6,1.5,1.5,1.5,0,0,1,7.5,0Zm6,0A1.5,1.5,0,1,1,12,1.5,1.5,1.5,0,0,1,13.5,0Z",
      fill: "#e3e4e5"
    })
  }));
};
IconEllipsis.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "3",
  viewBox: "0 0 15 3"
};
function MenuItem(_ref) {
  let {
    index,
    intersectCallback,
    root,
    children
  } = _ref;
  const item = useRef();
  const opts = {
    root: root,
    rootMargin: "3px",
    threshold: 1.0
  };
  const intersect = useIntersectionObserver(item, opts);
  useEffect(() => {
    intersectCallback(intersect, index);
  }, [intersect]);
  return /*#__PURE__*/_jsx("li", {
    className: classnames(styles.item, {
      [styles.intersect]: intersect
    }),
    ref: item,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.itemInner,
      children: children
    })
  });
}
export default function OverflowMenu(_ref2) {
  let {
    className,
    children
  } = _ref2;
  const root = useRef();
  const {
    0: state,
    1: dispatch
  } = useReducer((state, action) => {
    switch (action.type) {
      case "add":
        return [...state, action.index];
      case "remove":
        return state.filter(idx => idx != action.index);
    }
  }, []);
  const callback = useCallback((intersect, index) => {
    if (intersect) {
      dispatch({
        type: "remove",
        index
      });
    } else {
      dispatch({
        type: "add",
        index
      });
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, className),
    children: [/*#__PURE__*/_jsx("ul", {
      className: styles.menu,
      ref: root,
      children: Children.map(children, (child, i) => /*#__PURE__*/_jsx(MenuItem, {
        index: i,
        intersectCallback: callback,
        root: root.current,
        children: child
      }, `menu-item-${i}`))
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.dropdown, {
        [styles.show]: state.length > 0
      }),
      children: /*#__PURE__*/_jsx(DropdownMenu, {
        button: /*#__PURE__*/_jsx(IconEllipsis, {}),
        scopedClass: dropDownStyles.forOverflowMenu,
        mouseOver: true,
        right: true,
        children: /*#__PURE__*/_jsx("div", {
          className: dropDownStyles.item,
          children: state.sort().map(idx => {
            const element = Children.toArray(children)[idx];
            if (!element) return null;
            return /*#__PURE__*/cloneElement(element, {
              key: `overflow-dropdown-menu-${idx}`
            });
          })
        })
      })
    })]
  });
}